import type { Request } from 'express'
import { getCookies } from 'lib/web/cookieUtils'
import { sha256 } from 'lib/utils/createHashUtils'

export function stitchedSeedIdCookieName(memberId: string) {
  const hashedId = sha256(memberId).substring(0, 16)
  return `lux_stitched_seed_id_${hashedId}`
}

// This function uses either the request object (in the case of being used server-side)
// or the getCookies function if used client-side
export function getStitchedSeedId(memberId?: string, req?: Request): string | undefined {
  if ((IS_SSR && !req) || !memberId) return undefined

  const cookies = req ? req.cookies as Record<string, string> : getCookies()

  return cookies[stitchedSeedIdCookieName(memberId)]
}
